export default "__VITE_ASSET__DP4xwQaP__"